export enum SapiErrorCodes {
    // Alias already taken by some other user
    AliasConflict = '0x80048103',

    // Alias marked as primary in user's account aliases
    PrimaryAliasConflict = '0x8004834a',

    // Alias already added to user's account aliases
    AliasAlreadyExist = '0x8004834b',

    // Alias added as security proof
    ProofAlreadyExists = '0x80049c0b',

    // Maximum aliases(10) add limit reached
    MaximumAliasesReached = '0x80043472',

    // Alias not in valid format
    InvalidFormat = '0x800482e6',

    // Any other alias error not captured here
    Unknown = '0',

    // Alias marked primary cannot be deleted
    PrimaryAliasRemovalBlocked = '1',

    // Non prosumer alias deletion not allowed
    NonProsumerAliasRemovalBlocked = '2',
}
